import {Injectable, inject} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {filter, skip} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private router: Router = inject(Router);
  private initialized = false;

  constructor() {
    this.init();
  }

  private init(): void {
    if (!environment.production) {
      console.log('[Analytics] GA disabled (dev mode)');
      return;
    }

    const trackingId = (environment as { gaTrackingId?: string }).gaTrackingId;
        if (trackingId) {
          // Load gtag script dynamically
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
          document.head.appendChild(script);

          window.dataLayer = window.dataLayer || [];
          window.gtag = function (...args: unknown[]) {
            window.dataLayer.push(args);
          };
          window.gtag('js', new Date());
          window.gtag('config', trackingId, {
            send_page_view: false,
          });

          this.initialized = true;
        }

    // Track page views on navigation
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        skip(1),
      )
      .subscribe((event) => {
        this.pageView(event.urlAfterRedirects);
      });
  }

  pageView(path: string, title?: string): void {
    if (!this.initialized) return;
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title ?? document.title,
      page_location: window.location.origin + path,
    });
  }

  event(
    action: string,
    params?: Record<string, string | number | boolean>,
  ): void {
    if (!this.initialized) return;
    window.gtag('event', action, params);
  }
}
